<template>
  <div id="say-hotels">
    <main v-if="!loading">
        <Header></Header>
        <div v-for="city of cities" :key="city.locationCode">
          <HotelsCity :hotels="city.hotels" :name="city.locationName"></HotelsCity>
        </div>
    </main>
    <Footer></Footer>
    <Transition>
        <BlockUI v-if="loading"></BlockUI>
    </Transition>
  </div>
</template>

<script>
import BlockUI from '@/components/tools/BlockUI.vue';
import Header from '@/components/hotels/Header.vue';
import HotelsCity from '@/components/hotels/HotelsCity.vue';
import Footer from '@/components/tools/Footer.vue';
import '@/assets/css/main.scss';
const api = window.api;
export default {
  name: 'SayHotels',
  data() {
    return {
      showModal: false,
      loading: true,
    }
  },
  computed: {
    cities() {
      return this.$store.getters.cities;
    }
  },
  async mounted() {
    this.loading = true;
    const isGroup = this.$route.query.groups === 'true';
    const sellerEndpoint = isGroup ? '/api/groups/group_seller_db' : '/api/tpsql/trip_seller_db';
    const hotelsEndpoint = isGroup ? '/api/groups/group_booking_hotels' : '/api/tpsql/trip_booking_hotels';

    api.get(sellerEndpoint, this.$route.query, null, (r) => {
      if (r) {
        this.$store.commit('setSeller', r);
      }
    });
    let res = await api.get(hotelsEndpoint, this.$route.query);
    if (res) {
      this.$store.commit('setBookingHotels', res);
      this.$store.commit('setNames', {values: [{CATEGORY: 'PAX', MESSAGE_TEXT: res.pax_name}], isPCM: false});

      if (!isGroup) {
        api.get('/api/tpsql/pcm_client_image', this.$route.query, null, (result) => {
          this.$store.commit('setClientImage', result);
        });
      }
      this.$store.commit('setQuery', this.$route.query);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  },
  components: {
    BlockUI,
    Header,
    HotelsCity,
    Footer
  }
}
</script>

<style scoped>
.trip-body {
  overflow: scroll;
}

.v-leave-active {
  transition: opacity 1s ease;
}

.v-leave-to {
  opacity: 0;
}
</style>
